import { SET_DELETE_IMAGE } from "../actions";

const deleteDataImage = (state = [], action) => {
  switch (action.type) {
    case SET_DELETE_IMAGE:
      return [...action.value];
    default:
      return state;
  }
};

export default deleteDataImage;
